import { getOverclaimUploadDocumentFor } from '@App/api/routes/overclaim'
import Button from '@Components/Buttons/Button'
import React from 'react'
import { openExternalHttp } from '@App/navigation/safe-navigation'

interface DocumentDownloadActionProps {
    rightsholderId: number
    memberUploadId: number
    overclaimHeaderId: number
    size: number
}

const formatMegabytes = (bytes: number) => `${(bytes / (1024 * 1024)).toFixed(2)} MB`

const DocumentDownloadAction = ({
    overclaimHeaderId,
    memberUploadId,
    rightsholderId,
    size,
}: DocumentDownloadActionProps) => {
    const downloadDocument = async () => {
        const response = await getOverclaimUploadDocumentFor(rightsholderId, overclaimHeaderId, memberUploadId)
        openExternalHttp(response.data.downloadLink)
    }

    return (
        <div className="overclaim-document-actions-cell aligned">
            <Button className="overclaim-download-button" mainColor type="secondary-small" onClick={downloadDocument}>
                Download
            </Button>
            <div className="overclaim-document-size">{formatMegabytes(size)}</div>
        </div>
    )
}

export default DocumentDownloadAction
